import type { Session, User } from "@supabase/supabase-js";
import { createContext } from "react";

interface AuthContext {
    session: Session | null;
    user: User | null;
    loading: boolean;
    // Authorization (our allowlist), separate from authentication (Supabase
    // proves identity). null = not yet determined; gates routing in
    // AuthenticatedRouteGuard.
    approved: boolean | null;
}

export const AuthContext = createContext<AuthContext>({
    session: null,
    user: null,
    loading: true,
    approved: null
});
